import React, { useState } from "react";

function useModal() {
  const [visable, setVisable] = useState({
    TeacherModal: false,
    PurchaseModal: false,
    NotificationModal: false,
    ProfileModal: false,
    ChangePasswordModal: false,
    StudentDetailModel: false,
    ExtraDetailModel: false,
    CautionModel: false,
    TrialModalOpen: false,
  });

  const Open = (modalName) => {
    // PurchaseModal_ReadingModel1_1 gibi ID'leri işle
    if (modalName.startsWith("PurchaseModal_")) {
      setVisable((prev) => ({ ...prev, PurchaseModal: true }));
    } else {
      setVisable((prev) => ({ ...prev, [modalName]: true }));
    }
  };

  const Close = (modalName) => {
    if (modalName.startsWith("PurchaseModal_")) {
      setVisable((prev) => ({ ...prev, PurchaseModal: false }));
    } else {
      setVisable((prev) => ({ ...prev, [modalName]: false }));
    }
  };

  return { visable, Open, Close };
}

export default useModal;
